import { LitElement, html, nothing } from 'lit-element';

class AppPagination extends LitElement {
    static get properties() {
        return {
            prevPage: { type: Object },
            nextPage: { type: Object }
        };
    }

    createRenderRoot() {
        return this; // Use light DOM instead of shadow DOM
    }

    render() {
        return html`
            <div class="pagination">
                ${this.prevPage
                    ? html` <a
                          href="${this.prevPage.url}"
                          class="pagination-btn prev"
                          tabindex="0"
                          aria-label="Previous: ${this.prevPage.title}"
                          @keydown=${e => this._handleKeyDown(e, this.prevPage.url)}
                      >
                          <svg
                              class="arrow-icon"
                              xmlns="http://www.w3.org/2000/svg"
                              width="20"
                              height="20"
                              viewBox="0 0 24 24"
                              fill="none"
                              stroke="currentColor"
                              stroke-width="2"
                              stroke-linecap="round"
                              stroke-linejoin="round"
                          >
                              <line x1="19" y1="12" x2="5" y2="12"></line>
                              <polyline points="12 19 5 12 12 5"></polyline>
                          </svg>
                          <div class="page-text">
                              <span class="direction">Previous</span>
                              <span class="title">${this.prevPage.title}</span>
                          </div>
                      </a>`
                    : html`<div></div>`}
                ${this.nextPage
                    ? html`<a
                          href="${this.nextPage.url}"
                          class="pagination-btn next"
                          tabindex="0"
                          aria-label="Next: ${this.nextPage.title}"
                          @keydown=${e => this._handleKeyDown(e, this.nextPage.url)}
                      >
                          <div class="page-text">
                              <span class="direction">Next</span>
                              <span class="title">${this.nextPage.title}</span>
                          </div>
                          <svg
                              class="arrow-icon"
                              xmlns="http://www.w3.org/2000/svg"
                              width="20"
                              height="20"
                              viewBox="0 0 24 24"
                              fill="none"
                              stroke="currentColor"
                              stroke-width="2"
                              stroke-linecap="round"
                              stroke-linejoin="round"
                          >
                              <line x1="5" y1="12" x2="19" y2="12"></line>
                              <polyline points="12 5 19 12 12 19"></polyline>
                          </svg>
                      </a>`
                    : html`<div></div>`}
            </div>
        `;
    }

    _handleKeyDown(e, url) {
        if (e.key === 'Enter' || e.key === ' ') {
            e.preventDefault();
            window.location.href = url;
        }
    }
}

customElements.define('app-pagination', AppPagination);
